import { render, staticRenderFns } from "./PoHomeworkDetails.vue?vue&type=template&id=3d424498&scoped=true"
import script from "./PoHomeworkDetails.vue?vue&type=script&lang=js"
export * from "./PoHomeworkDetails.vue?vue&type=script&lang=js"
import style0 from "./PoHomeworkDetails.vue?vue&type=style&index=0&id=3d424498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d424498",
  null
  
)

export default component.exports